import * as tslib_1 from "tslib";
import { HttpParams } from '@angular/common/http';
import { Api } from './api.service';
var ShipperApi = /** @class */ (function (_super) {
    tslib_1.__extends(ShipperApi, _super);
    function ShipperApi() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.controllerName = 'api/shipper';
        return _this;
    }
    ShipperApi.prototype.create = function (user) {
        return this.post('api/shipper', { ObjectId: user.oid, Email: user.email, DisplayName: user.displayName, Type: user.type });
    };
    ShipperApi.prototype.update = function (data) {
        return this.put(this.controllerName, data);
    };
    ShipperApi.prototype.getRemainderCredit = function (shipperId) {
        var params = new HttpParams({});
        return this.get("shipper/detail/" + shipperId + "/RemainderCredit", params);
    };
    ShipperApi.prototype.cancelRequest = function (id) {
        return this.get(this.controllerName + "/cancel-request/" + id);
    };
    ShipperApi.prototype.getShipperProfile = function (modelId) {
        return modelId ? this.get(this.controllerName + "/" + modelId) : this.get("" + this.controllerName);
    };
    ShipperApi.prototype.exitRequestBeforePayment = function (id) {
        return this.get(this.controllerName + "/exit-request-before-payment/" + id);
    };
    ShipperApi.prototype.exitRequestAfterPayment = function (id) {
        return this.get(this.controllerName + "/exit-request-after-payment/" + id);
    };
    ShipperApi.prototype.requestBookingRevision = function (id) {
        return this.get(this.controllerName + "/request-booking-revision/" + id);
    };
    ShipperApi.prototype.getShipperDatatable = function (request) {
        return this.datatable("api/shipper/get-datatable-shipper", request);
    };
    ShipperApi.prototype.getShipperStatistic = function () {
        return this.get(this.controllerName + "/get-statistic-shipper");
    };
    ShipperApi.prototype.isShowList = function () {
        return this.get(this.controllerName + "/show-shipper-list");
    };
    ShipperApi.prototype.isShowFreightPostRequestList = function () {
        return this.get(this.controllerName + "/show-shipper-freight-post-request-list");
    };
    ShipperApi.prototype.isShowDeal = function () {
        return this.get(this.controllerName + "/show-shipper-deal");
    };
    ShipperApi.prototype.isShowRefund = function () {
        return this.get(this.controllerName + "/show-shipper-refund");
    };
    ShipperApi.prototype.isShowPenalty = function () {
        return this.get(this.controllerName + "/show-shipper-penalty");
    };
    ShipperApi.prototype.getShipperReward = function () {
        return this.get(this.controllerName + "/get-shipper-reward");
    };
    ShipperApi.prototype.isExist = function (id) {
        return this.get(this.controllerName + "/check-exist/" + id);
    };
    ShipperApi.prototype.updateServicesAndCondition = function (command) {
        return this.post(this.controllerName + "/update-services-and-condition", command);
    };
    ShipperApi.prototype.downloadBusinessRegistrationsFile = function (id, fileName) {
        return this.download(fileName, this.controllerName + "/download-business-registrations-file/" + id);
    };
    return ShipperApi;
}(Api));
export { ShipperApi };
